import { ProductName, } from '@zurich/api/contract';
import { timeZoneClient, timeZoneServer } from '@zurich/common/contexts';
import { addMonths, addYears, startOfMonth } from '@zurich/common/forms';
import { dateToApiDateTime } from '@zurich/common/types';
const isTodayTheFirst = new Date().getDate() === 1;
const endDate = dateToApiDateTime(timeZoneClient, timeZoneServer, startOfMonth(addMonths(addYears(new Date(), 1), isTodayTheFirst ? 0 : 1)));
const startDate = dateToApiDateTime(timeZoneClient, timeZoneServer, new Date());
// TODO: unique start and end date
// WARNING: This default is used for the Offer which goes into
// live production. Changing any critical fields
// in this const could lead to critical bugs in production. If
// you are unsure about the importance of a field, please check
// with another developer, tester, or insurance expert.
export const offerInsuranceSegmentsDefault = [
    {
        durationTime: 0,
        tariffGeneration: '-',
        limitationOfTransferability: {
            selected: 'false',
        },
        discounts: [
            {
                description: '',
                id: '',
                type: 'negativeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'employeeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'couponDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'onlineDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'campaingDiscount',
                value: 0,
                discountSelected: false,
            },
            {
                description: '',
                id: '',
                type: 'winterDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'customerSpecificDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'specialDiscount',
                value: 0,
            },
        ],
        endDate,
        segmentKey: '03.0_IU',
        replacementApplicationId: '',
        selectableUnits: [
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'totalAmount',
                        value: 50000,
                        selected: 'true',
                    },
                ],
                name: '03.0_IU_PermDisability',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                name: '03.0_IU_ChildBenefit',
                id: '',
                selected: 'false',
                packageType: 'standaloneCover',
            },
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'totalAmount',
                        value: 10000,
                        selected: 'true',
                    },
                ],
                name: '03.0_IU_Death',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'totalAmount',
                        value: 0,
                        selected: 'true',
                    },
                ],
                name: '03.0_IU_DayMoney',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'totalAmount',
                        value: 0,
                        selected: 'true',
                    },
                ],
                name: '03.0_IU_AccidentCosts',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
        ],
        selected: 'false',
        startDate,
        indexationInfo: {
            index: 'K',
            indexValue: 0,
            dateOfIssuingPolicy: '2022-10-25',
        },
        premiumCuttingWkz: 1,
    },
    {
        tariffGeneration: '-',
        questionnaire: {
            genericQuestions: [],
            motorLiability: {
                boMaLevelExtern: '9',
                boMaLevelIntern: '9',
                questionType: 'q_motorLiability',
            },
            motorGeneralQuestions: {
                questionType: 'q_motorGeneral',
                environmentDiscount: 'noDiscount',
                changeOfVehicle: false,
                noYearlyPaymentSurcharge: false,
            },
        },
        limitationOfTransferability: {
            selected: 'false',
        },
        discounts: [
            {
                description: '',
                id: '',
                type: 'negativeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'employeeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'couponDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'onlineDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'campaingDiscount',
                value: 0, // this value is set by vpms
                discountSelected: false,
            },
            {
                description: '',
                id: '',
                type: 'winterDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'customerSpecificDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'specialDiscount',
                value: 0,
            },
        ],
        endDate,
        segmentKey: '01.0_AH',
        replacementApplicationId: '',
        selectableUnits: [
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'totalAmount',
                        value: 25000000,
                        selected: 'true',
                    },
                ],
                name: '01.0_AH_Basic',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'percentageIV',
                        value: 0,
                        selected: 'false',
                    },
                ],
                name: '01.0_AH_ForeignPlus',
                id: '',
                selected: 'false',
                packageType: 'standaloneCover',
            },
            {
                name: '01.0_AH_SumInsured',
                limits: [
                    {
                        limitType: 'totalAmount',
                        value: 25000000,
                    },
                ],
                packageType: 'standaloneCover',
            },
            {
                name: '01.0_AH_motorAssistance',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                name: 'deductibleVariant',
                deductibles: [
                    {
                        deductibleType: 'totalAmount',
                        deductibleVariant: 'E',
                    },
                ],
                packageType: 'standaloneCover',
            },
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'percentageIV',
                        value: 0,
                        selected: 'false',
                    },
                ],
                name: '01.0_AH_rentalCar',
                id: '',
                selected: 'false',
                packageType: 'standaloneCover',
            },
        ],
        selected: 'false',
        startDate,
        indexationInfo: {
            index: 'S',
            indexValue: 0,
            dateOfIssuingPolicy: '2022-10-25',
        },
        premiumCuttingWkz: 1,
    },
    {
        durationTime: 0,
        tariffGeneration: '-',
        questionnaire: {
            genericQuestions: [],
            motorCasco: {
                inputTaxDeduction: false, // inputTaxDeduction should always be defaulted to false! A default of true would give the customer a tax discount
                noDeductibleForNaturalCatastrophe: false,
                noDeductiblesForSmallGlasses: false,
                additionalPayout: false,
                additionalPayoutTotalDamage: false,
                grossNegligence: false,
                insuredGoods: 'noGoods',
                questionType: 'q_motorCasco',
                environmentDiscount: 'noDiscount',
            },
            motorLiability: {
                questionType: 'q_motorLiability',
            },
            motorGeneralQuestions: {
                questionType: 'q_motorGeneral',
                environmentDiscount: 'noDiscount',
                changeOfVehicle: false,
                noYearlyPaymentSurcharge: false,
            },
            motorPartialCasco: {
                parkDamageIncluded: false,
                questionType: 'q_motorPartialCasco',
            },
        },
        limitationOfTransferability: {
            selected: 'false',
        },
        discounts: [
            {
                description: '',
                id: '',
                type: 'negativeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'employeeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'couponDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'onlineDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'campaingDiscount',
                value: 0, // this value is set by vpms
                discountSelected: false,
            },
            {
                description: '',
                id: '',
                type: 'winterDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'customerSpecificDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'specialDiscount',
                value: 0,
            },
        ],
        endDate,
        segmentKey: '02.1_VK',
        replacementApplicationId: '',
        selectableUnits: [
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: false,
                        deductibleType: 'totalAmount',
                        id: '',
                        value: 290,
                        selected: 'true',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'percentageIV',
                        value: 0,
                        selected: 'false',
                    },
                ],
                name: '02.1_VK_Basic',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'percentageIV',
                        value: 0,
                        selected: 'false',
                    },
                ],
                name: '02.1_VK_SafetyCloth',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                name: 'deductibleVariant',
                deductibles: [
                    {
                        deductibleType: 'totalAmount',
                        deductibleVariant: 'E',
                    },
                ],
                packageType: 'standaloneCover',
            },
        ],
        selected: 'false',
        startDate,
        indexationInfo: {
            index: 'T',
            indexValue: 0,
            dateOfIssuingPolicy: '2022-10-25',
        },
        premiumCuttingWkz: 1,
    },
    {
        durationTime: 0,
        tariffGeneration: '-',
        questionnaire: {
            genericQuestions: [],
            motorCasco: {
                inputTaxDeduction: false, // inputTaxDeduction should always be defaulted to false! A default of true would give the customer a tax discount
                noDeductibleForNaturalCatastrophe: false,
                noDeductiblesForSmallGlasses: false,
                additionalPayout: false,
                additionalPayoutTotalDamage: false,
                grossNegligence: false,
                insuredGoods: 'noGoods',
                questionType: 'q_motorCasco',
                environmentDiscount: 'noDiscount',
            },
            motorLiability: {
                questionType: 'q_motorLiability',
            },
            motorGeneralQuestions: {
                questionType: 'q_motorGeneral',
                environmentDiscount: 'noDiscount',
                changeOfVehicle: false,
                noYearlyPaymentSurcharge: false,
            },
            motorPartialCasco: {
                parkDamageIncluded: true,
                questionType: 'q_motorPartialCasco',
            },
        },
        limitationOfTransferability: {
            selected: 'false',
        },
        discounts: [
            {
                description: '',
                id: '',
                type: 'negativeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'employeeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'couponDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'onlineDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'campaingDiscount',
                value: 0, // this value is set by vpms
                discountSelected: false,
            },
            {
                description: '',
                id: '',
                type: 'winterDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'customerSpecificDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'specialDiscount',
                value: 0,
            },
        ],
        endDate,
        segmentKey: '02.2_TK',
        replacementApplicationId: '',
        selectableUnits: [
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'totalAmount',
                        id: '',
                        value: 290,
                        selected: 'true',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'percentageIV',
                        value: 0,
                        selected: 'false',
                    },
                ],
                name: '02.2_TK_Basic',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'percentageIV',
                        value: 0,
                        selected: 'false',
                    },
                ],
                name: '02.2_TK_SafetyCloth',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
            {
                name: 'deductibleVariant',
                deductibles: [
                    {
                        deductibleType: 'totalAmount',
                        deductibleVariant: 'E',
                    },
                ],
                packageType: 'standaloneCover',
            },
        ],
        selected: 'false',
        startDate,
        indexationInfo: {
            index: 'T',
            indexValue: 0,
            dateOfIssuingPolicy: '2022-10-25',
        },
        premiumCuttingWkz: 1,
    },
    {
        durationTime: 0,
        tariffGeneration: '-',
        limitationOfTransferability: {
            selected: 'false',
        },
        discounts: [
            {
                description: '',
                id: '',
                type: 'negativeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'employeeDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'couponDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'onlineDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'campaingDiscount',
                value: 0,
                discountSelected: false,
            },
            {
                description: '',
                id: '',
                type: 'winterDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'customerSpecificDiscount',
                value: 0,
            },
            {
                description: '',
                id: '',
                type: 'specialDiscount',
                value: 0,
            },
        ],
        endDate,
        segmentKey: '04.0_AS',
        replacementApplicationId: '',
        selectableUnits: [
            {
                risks: [
                    {
                        riskType: 'UNBEF',
                        id: '',
                        value: null,
                    },
                ],
                clauses: [
                    {
                        id: '',
                        clauseType: 'AH_NON_STD',
                    },
                ],
                deductibles: [
                    {
                        default: true,
                        deductibleType: 'percentageIV',
                        id: '',
                        value: 0,
                        selected: 'false',
                        deductibleVariant: 'E',
                    },
                ],
                printingOrder: '',
                limits: [
                    {
                        default: true,
                        id: '',
                        limitType: 'percentageIV',
                        value: 0,
                        selected: 'false',
                    },
                ],
                name: '04.0_AS_Basic',
                id: '',
                selected: 'true',
                packageType: 'standaloneCover',
            },
        ],
        selected: 'false',
        startDate,
        indexationInfo: {
            index: 'K',
            indexValue: 0,
            dateOfIssuingPolicy: '2022-10-25',
        },
        premiumCuttingWkz: 1,
    },
];
export const offerMock = {
    id: '00000000-0000-0000-0000-000000000000',
    approvalDecisions: [],
    insuredObjects: [
        {
            insuredObjectType: 'Vehicle',
            vehicleType: 'PKW',
            manufacturer: 'Audi',
            model: 'A6',
            modelType: '40 TDI sport S-tronic',
            performanceIceKw: 77,
            performanceKwTotal: 77,
            performanceNonIceKw: 77,
            performanceIcePs: 104,
            co2Emission: 176,
            constructionYear: 2020,
            ccm: 1968,
            listPrice: 61023,
            noOfSeats: 5,
            payloadInTons: 535,
            engineType: 'diesel',
            usageType: 'ownUse',
            initialRegistrationDate: '2020-11-11',
            initialRegistrationYear: 2020,
            telematik: 'false',
            leasingVehicle: 'false',
            maxTotalWeightInTons: 1,
            registrationDistrict: 'B',
            additionalEquipments: [],
            insuranceSegments: offerInsuranceSegmentsDefault.map((segment) => {
                const keys = ['01.0_AH', '02.1_VK', '04.0_AS'];
                return keys.includes(segment?.segmentKey)
                    ? { ...segment, selected: 'true' }
                    : segment;
            }),
            insuredObjectId: '1',
            licensePlateType: 'normal',
        },
    ],
    firstTimePolicyHolderBM: 'firstTimeWithBM',
    paymentWay: 'Bankinkasso',
    salesChannel: 'TiedAgent',
    products: [
        {
            productFeatures: [
                {
                    existingFamilyPolicyNo: '',
                    insuranceConfirmationNumber: undefined,
                    intInsuranceCard: 'unset',
                    licensePlateDeposit: 'unset',
                    bonusGiftByDirectorsBoMaLevel: 9,
                    bonusGiftByDirectors: 'unset',
                    rendementChecked: 'unset',
                    infrequentDrivers: 'unset',
                    driverUnder23: 'true',
                    bonusMalusLevelFreeDemageAction: '0',
                    productfeatureType: 'pF_AddOnOptionsMotor',
                    boMaAdvantage: false,
                },
                {
                    licenseWithdrawal: 'false',
                    withdrawalReason: '',
                    productfeatureType: 'pF_LicenseWithdrawal',
                },
            ],
            relatedCustomerSegment: 'private',
            productId: '1020',
            productName: ProductName.NMP,
            salesProductId: '52f43c4d-a536-4628-86d8-4f8c2fec3c95',
            productCategory: {
                advisoryDocumentation: {
                    productAdvisoryDeclined: 'false',
                    offerCorrespondsRecommendation: 'false',
                    recommendationData: [
                        { value: '2016', key: 'productionyear' },
                        { value: '1', key: 'mtpl' },
                        { value: '1', key: 'naturalDisasters' },
                        { value: '1', key: 'parkingDemage' },
                        { value: '1', key: 'collisionDemage' },
                        { value: '1', key: 'Leasingfahrzeug' },
                        { value: '1', key: 'specialConcernsTrueFalse' },
                        {
                            value: 'Die Soundanlage im Wert von 5.000 Euro muss mitversichert werden.',
                            key: 'specialConcerns',
                        },
                    ],
                    advisoryData: [],
                    wishesAndNeedsDecisions: [
                        {
                            textTemplateId: 'WaN_004a',
                            need: 'Vollkasko',
                            recommandation: 'Haftpflicht und Vollkasko',
                            coverGap: 'True',
                            text: 'Der Kunde hat bekanntgegeben, dass er sich gegen Schäden, die sein Fahrzeug bei seinem Betrieb anderen zufügt, versichern möchte.Der Kunde hat beganntgegeben, dass er sich gegen Schäden am eigenen Fahrzeug durch Kollision versichern möchte.Der Kunde hat den Wunsch nach einer Absicherung gegen Parkschaden und Vandalismus bekanntgegeben.Der Kunde hat den Wunsch nach einer Absicherung gegen Naturgewalten, Wildschaden oder Diebstahl bekanntgegeben.',
                            coverGapDescription: 'Auf Basis der Ermittlung der Wünsche und Bedürfnisse wurde der Bedarf einer Vollkaskoversicherung erkannt. Diese wurde im Produkt nicht eingeschlossen.',
                        },
                    ],
                },
                categoryName: 'motor',
                categoryId: 'motor',
            },
        },
    ],
    questionnaire: {
        previousInsurance: {
            questionType: 'q_previousInsurance',
            prevPolicyTerminated: 'false',
            affectedSegment: [],
        },
        previousInsurances: [
            {
                questionType: 'q_previousInsurance',
                prevPolicyTerminated: 'false',
                terminatingInsuranceCompanyCode: '2444323',
                affectedSegment: [],
            },
            {
                questionType: 'q_previousInsurance',
                prevPolicyTerminated: 'false',
                terminatingInsuranceCompanyCode: '3204671',
                affectedSegment: [],
            },
            {
                questionType: 'q_previousInsurance',
                prevPolicyTerminated: 'false',
                terminatingInsuranceCompanyCode: '4082649',
                affectedSegment: [],
            },
        ],
        genericQuestions: [
            {
                questionId: 'declarationELU',
                questionType: 'genericQuestion',
                answer: 'true',
            },
        ],
        motorGeneralQuestions: {
            questionType: 'q_motorGeneral',
            environmentDiscount: 'noDiscount',
            changeOfVehicle: false,
            noYearlyPaymentSurcharge: false,
            boMaOld: 9,
            boMaNew: 9,
        },
    },
    austrianLaw: 'true',
    paymentInterval: 'monthly',
    discounts: [],
    createdBy: '',
    intermediaryInformation: {
        intermediaryId: '227443',
        employeeNumber: '89416',
        intermediaryAccounts: [{ Account: '4099923' }],
        usedIntermediaryAccount1: {},
        intermediaryType: 'TiedAgent',
        approvalLimit: '',
        discountLimits: [
            {
                key: 'SR_AH',
                value: 10,
            },
            {
                key: 'SR_AK',
                value: 10,
            },
            {
                key: 'SR_AU',
                value: 10,
            },
            {
                key: 'OSR_AH',
                value: 0,
            },
            {
                key: 'OSR_AK',
                value: 0,
            },
            {
                key: 'OSR_AU',
                value: 0,
            },
        ],
    },
    parties: [
        {
            diplomatType: 'blue',
            firstName: 'Georg',
            lastName: 'Schelkshorn Unchaged',
            degreePreFix: 'DIin',
            gender: 'male',
            dayOfBirth: '1996-04-21T00:00:00Z',
            occupationRiskGroup: 'riskGroup1',
            bankAccounts: [
                {
                    iban: 'AT501400056348854756',
                    id: 'AT501400056348854756',
                    bic: '',
                },
            ],
            partyId: 'P000507808',
            partyType: 'person',
            addressRoles: [
                {
                    addressRoleType: 'hauptwohnsitz',
                    address: {
                        country: 'AT',
                        streetName: 'Am Moosbach',
                        city: 'Grabern',
                        postalCode: '2020',
                        houseNo: '12',
                    },
                },
                {
                    addressRoleType: 'zustelladresse',
                    address: {
                        country: 'AT',
                        streetName: 'Am Graben',
                        city: 'Wien',
                        postalCode: '1010',
                        houseNo: '1',
                    },
                },
            ],
            contactRoles: [
                {
                    contactInformation: {
                        contactType: 'emailAddress',
                        value: 'georg@schelkshorninger.com',
                    },
                    contactRoleType: 'contact',
                },
                {
                    contactInformation: {
                        contactType: 'mobilePhone',
                        value: '+43676123123563',
                    },
                    contactRoleType: 'contact',
                },
            ],
        },
        {
            diplomatType: 'non',
            firstName: 'Rabi',
            lastName: 'Warnecke-Hofstetter',
            gender: 'unknown',
            bankAccounts: [],
            partyId: '214212',
            partyType: 'person',
            addressRoles: [],
            contactRoles: [],
        },
    ],
    state: 'calculationState',
    replacedPolicyNo: [],
    participantRoles: [
        {
            type: 'policyHolder',
            partyId: 'P000507808',
            mainFlag: true,
        },
        {
            type: 'intermediary',
            partyId: '214212',
            mainFlag: true,
        },
    ],
    firstTimePolicyHolder: false,
    exemptionFromMotorTax: 'false',
    diplomatTaxExemption: false,
    effectiveDateForIndexation: '2022-10-27',
};
export function getMockOfferId() {
    const offerId = offerMock['id'];
    if (offerId === undefined) {
        throw new Error('Invalid mock offer id');
    }
    return offerId;
}
export function isMockOfferId(id) {
    return id === getMockOfferId();
}
